import Sketch from "./module.js";
//import myimage from "../img/pin.png";

const myimage =  require("../img/Pinnacle_Logo_White_PNG.png");

new Sketch({
  dom: document.getElementById("container"),
  config: true,
  url: myimage,
  mouseover: "#mouseover",
  settings:{
    number: 7200,
    trails: .05,
    size: 0.6,
    velocity: 0.6,
    velocityDifference: 0.05,
    randomness: 2,
    sideScale: 2,
    speedScale: 10
    
  }
});

